import { Text, Title } from '@components/v2/ui';
import {
	Flex,
	NumberFormatter,
	Stack,
} from '@mantine/core';
import Decimal from 'decimal.js';
import { useTranslation } from 'react-i18next';

type MeasurabilitiesOffsetSummaryProps = {
	totalQuantity: number;
	averagePrice: number;
	totalCost: number;
};

export const MeasurabilitiesOffsetSummary = ({
	totalQuantity,
	averagePrice,
	totalCost,
}: MeasurabilitiesOffsetSummaryProps) => {
	const { t } = useTranslation();

	const roundedTotalQuantity = new Decimal(totalQuantity)
		.mul(100)
		.ceil()
		.div(100)
		.toNumber();

	return (
		<Stack w="100%" gap="24px">
			{/* Total quantité */}
			<Flex justify="space-between" align="center">
				<Text
					variant="caption"
					c="var(--mantine-color-igluTextSecondary-9)"
				>
					{t('global.totalQuantity')}
				</Text>

				<Text
					variant="caption"
					c="var(--mantine-color-igluTextSecondary-9)"
				>
					<NumberFormatter
						value={roundedTotalQuantity}
						decimalScale={2}
						thousandSeparator=" "
						suffix=" tCO2"
					/>
				</Text>
			</Flex>

			<Stack gap="0px">
				{/* Prix moyen */}
				<Flex justify="space-between" align="center">
					<Text
						variant="button"
						c="var(--mantine-color-igluTextSecondary-9)"
					>
						{t('global.averagePriceExclVat')}
					</Text>

					<Text
						variant="subtitle1"
						c="var(--mantine-color-igluBlue-9)"
					>
						<NumberFormatter
							value={averagePrice}
							decimalScale={3}
							thousandSeparator=" "
							suffix=" € tCO2"
						/>
					</Text>
				</Flex>

				<Flex justify="space-between" align="center">
					<Text
						variant="subtitle1"
						c="var(--mantine-color-igluTextPrimary-9)"
					>
						{t('global.totalCost')}
					</Text>

					<Title
						order={6}
						c="var(--mantine-color-igluBlue-9)"
					>
						<NumberFormatter
							thousandSeparator=" "
							decimalSeparator=","
							value={totalCost}
							decimalScale={2}
							suffix="€"
						/>
					</Title>
				</Flex>
			</Stack>
		</Stack>
	);
};
